import { UpsellStatusType } from '@modules/husleie-framework/src/types/Upsell.entity';
import {
  UpsellDepositSubscriptionDetails,
  UpsellDepositSubscription,
} from '@modules/husleie-framework/src/types/UpsellDepositSubscription.entity';
import UpsellDepositSubscriptionState from '@modules/store/upsell/types/UpsellDepositSubscriptionState.entity';
import { MutationTree } from 'vuex';

export const mutations: MutationTree<UpsellDepositSubscriptionState> = {
  setUpsellDepositSubscriptionLoading: (state: UpsellDepositSubscriptionState, payload: boolean) => {
    state.loading = payload;
  },
  setUpsellDepositSubscriptionLoaded: (state: UpsellDepositSubscriptionState, payload: boolean) => {
    state.loaded = payload;
  },
  setUpsellDepositSubscriptionApiError: (state: UpsellDepositSubscriptionState, payload: boolean) => {
    state.apiError = payload;
  },
  setUpsellDepositSubscriptionDetails: (
    state: UpsellDepositSubscriptionState,
    payload: UpsellDepositSubscriptionDetails
  ) => {
    state.upsell.depositSubscriptionDetails = payload;
  },
  setUpsellDepositSubscriptionUuid: (state: UpsellDepositSubscriptionState, payload: string) => {
    state.upsell.depositSubscription.uuid = payload;
  },
  setUpsellDepositSubscriptionStatus: (state: UpsellDepositSubscriptionState, payload: UpsellStatusType) => {
    state.upsell.depositSubscription.status = payload;
  },
  setUpsellDepositSubscription: (state: UpsellDepositSubscriptionState, payload: UpsellDepositSubscription) => {
    state.upsell.depositSubscription = { ...state.upsell.depositSubscription, ...payload };
  },
};
